import {ConfirmDialog} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import {filterAndSearchSlice} from '../filter_and_search_slice';
import {useAppDispatch, useAppSelector} from 'src/js/store_hooks';

const I18N = defineMessages({
  DIALOG_TEXT: {
    id: 'common.export.confirmDialogLimit.text',
    defaultMessage:
      'Export limit for number of rows has been reached. Only the limited number of rows are displayed.',
    description: 'content text of confirm dialog',
  },
  DIALOG_TITLE: {
    id: 'common.export.confirmDialogLimit.title',
    defaultMessage: 'Export limit reached',
    description: 'title text of confirm dialog',
  },
});

const ExportLimitReachedContainer = ({stateId}) => {
  const [isDialogOpened, setIsDialogOpened] = useState(false);
  const dispatch = useAppDispatch();
  const exportRowsLimitReached = useAppSelector(
    (state) => state[stateId].exportRowsLimitReached
  );

  useEffect(() => {
    if (exportRowsLimitReached) {
      setIsDialogOpened(true);
    }
  }, [exportRowsLimitReached]);

  const handleDialogCancel = () => {
    // do nothing
    dispatch(
      filterAndSearchSlice.actions.setExportRowsLimitReached(stateId, false)
    );
  };

  const handleDialogConfirm = () => {
    setIsDialogOpened(false);
    dispatch(
      filterAndSearchSlice.actions.setExportRowsLimitReached(stateId, false)
    );
  };

  return (
    <ConfirmDialog
      isOpened={isDialogOpened}
      handleConfirm={handleDialogConfirm}
      handleCancel={handleDialogCancel}
      showCancel={false}
      titleText={I18N.DIALOG_TITLE.id}
    >
      <FormattedMessage {...I18N.DIALOG_TEXT} />
    </ConfirmDialog>
  );
};

ExportLimitReachedContainer.displayName = 'ExportLimitReachedContainer';

ExportLimitReachedContainer.propTypes = {
  stateId: PropTypes.string.isRequired,
};
export default ExportLimitReachedContainer;
